import React from "react";
import "../styles/StatisticsSection.css";

const StatisticsSection = () => {
  const stats = [
    {
      number: "500+",
      label: "Students Passed",
      icon: "🎓",
    },
    {
      number: "95%",
      label: "Pass Rate",
      icon: "✓",
    },
    {
      number: "20+",
      label: "Expert Instructors",
      icon: "👨‍🏫",
    },
    {
      number: "2-3",
      label: "Weeks to License",
      icon: "⚡",
    },
  ];

  return (
    <div className="statistics-section">
      <div className="container">
        <div className="stats-grid">
          {stats.map((stat, index) => (
            <div key={index} className="stat-card">
              <div className="stat-icon">{stat.icon}</div>
              <div className="stat-number">{stat.number}</div>
              <div className="stat-label">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default StatisticsSection;
